(ns frontend.ui.component.lp-portal.stacked-text-group.view
  (:require
   [frontend.ui.component.lp-portal.stacked-text-group.style :as style]
   [frontend.ui.component.lp-portal.strong-label.view :refer [strong-label]]
   [herb.core :refer [<class]]))

(defn stacked-text-group
  [title value]
  [:div {:class (<class style/stacked-text-group)}
   [strong-label title]
   [:div value]])
